import { useState } from "react";
import { Search, Settings } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface TagConfigurationsTabProps { tagId: string; }

export const TagConfigurationsTab = ({ tagId }: TagConfigurationsTabProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  // No backend API for configurations tags — show empty state
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="relative flex-1 max-w-sm">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
          <Input placeholder="Search configurations..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="pl-9" />
        </div>
      </div>
      <Card>
        <CardContent className="flex flex-col items-center justify-center py-12">
          <Settings className="h-12 w-12 text-muted-foreground mb-4" />
          <CardTitle className="text-center mb-2">No Configurations Found</CardTitle>
          <CardDescription className="text-center">
            Configuration tag assignments require a backend Configurations API. Coming soon.
          </CardDescription>
        </CardContent>
      </Card>
    </div>
  );
};
